const typesArray = [
  'int',
  'integer',
  'bigint',
  'smallint',
  'decimal',
  'numeric',
  'real',
  'double precision',
  'serial',
  'bigserial',
  'money',
  'character varying',
  'varchar',
  'character',
  'char',
  'text',
  'bytea',
  'timestamp without time zone',
  'timestamp with time zone',
  'date',
  'time without time zone',
  'time with time zone',
  'interval',
  'boolean',
  'enum',
  'uuid',
  'json',
  'jsonb',
  'xml',
  'tsvector',
  'tsquery',
  'point',
  'line',
  'lseg',
  'box',
  'path',
  'polygon',
  'circle',
  'cidr',
  'inet',
  'macaddr',
  'bit',
  'bit varying',
  'hstore',
  'ltree',
  'ltxtquery',
];

export default typesArray;
